/*
 |--------------------------------------------------------------------------
 | Web Routes
 |--------------------------------------------------------------------------
 |
 | This file declares all frontend routes used by the vue application
 | For Multipage Routing, include different files for the specific Page
 | Load each Component from the views Directory
 |
 */

import LoadingComponent from '@/components/loading';
import ErrorComponent from '@/pages/errors/404';

const template = (filename) => () => ({

	// The component to load (should be a Promise)
	component: import(/* webpackChunkName: '[request]' */ '@/pages/' + filename.replace(/\:/g, '/')),

	// A component to use while the async component is loading
    loading: LoadingComponent,

	// A component to use if the load fails
	error: ErrorComponent,

	// Delay before showing the loading component. Default: 200ms.
	delay: 200,

	// The error component will be displayed if a timeout is
	// provided and exceeded. Default: Infinity.
	timeout: 3000
});

export const routes = [

	/*
	|--------------------------------------------------------------------------
	| Default Routes
	|--------------------------------------------------------------------------
	*/

	{ path: '/', name: 'home', component: template('home') },

	{ path: '/salon', name: 'salon', component: template('salon') },
	// { path: '/karriere', name: 'jobs', component: template('jobs') },
	{ path: '/kontakt', name: 'contact', component: template('contact') },

	/*
	|--------------------------------------------------------------------------
	| Errors Routes
	|--------------------------------------------------------------------------
	*/
	{ path: '*', name: 'error:all', component: template('errors:404') }
];
